module.exports = __webpack_public_path__ + "img/selected7-min.bfc75b6d.png";